import { ProgramState, ProgramWeek, StepProps } from '../../models/programs';

export enum PFAProgramStep {
    ProgramOverviewStep = 'program-overview',
    CommonReactionsStep = 'common-reactions',
    CommonReactionsSecondStep = 'common-reactions-part-two',
    WhatHelpsStep = 'what-helps',
    WhatDoesNotHelpStep = 'what-does-not-help',
    GettingSupportStep = 'getting-support',
    RelaxationStrategiesStep = 'relaxation-strategies',
    AdditionalSupportStep = 'additional-support',
}

export type PFAProgramStepProps = StepProps<PFAProgramStep>;

export type PFAProgramWeek = ProgramWeek<PFAProgramStep[]>;

export type PFAProgramState = ProgramState<PFAProgramWeek[]>;

export interface AdditonalSupportResource {
    topic: string;
    icon: any;
    content?: string[];
    websites?: string[];
}
